'use strict';
import productAccordion from './company-index-accordion-collection';

module.exports = function () {
    productAccordion.init();
};
